import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'api';
import { TotalCmp, RefreshBtn } from './total.styled';
import { notify } from 'libs/common';

export const Total = ({ cnt, theme, title = 'found', after = '', count_limit, count_method, getFilter }) => {
  const { t } = useTranslation();
  const [cntReal, setCntReal] = useState(0);
  const [loading, setLoading] = useState(false);
  const filter_params = getFilter ? getFilter() : null;
  const flts = JSON.stringify(filter_params);
  useEffect(() => {
    // console.log('🚀 ~ clear');
    setCntReal(0);
  }, [flts]);

  const useRefresh = cnt === count_limit && !!count_method;

  const refresh = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    api
      .call(count_method, { filter_params })
      .then((res) => {
        // console.log('🚀 ~ refresh ~ res:', res);
        setCntReal(res);
        setLoading(false);
      })
      .catch((err) => {
        notify(t('messages.ВНИМАНИЕ!'), err);
        setLoading(false);
      });
  };

  const cl = loading ? 'loading' : '';
  const cntOk = cntReal > 0 ? cntReal : cnt ?? 0;

  return (
    <TotalCmp theme={theme}>
      {t('grid.' + title)}:&nbsp;<span>{cntOk}</span>
      {after}
      {useRefresh && (
        <RefreshBtn onClick={refresh} disabled={loading} className={cl} title={t('messages.Запросить точное количество записей')}>
          <img height={36} src="/images/refresh.png" alt="refresh" />
        </RefreshBtn>
      )}
    </TotalCmp>
  );
};
